import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatGridListModule } from '@angular/material/grid-list';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxMaskModule } from 'ngx-mask';
import { DurationModule } from '@web/app/pipes/duration/duration.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmModule } from '@web/app/components/dialogs/confirm';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LoadingModule } from '@web/app/components/loading/loading.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ArrayPipeModule } from '@pipes/array/array.module';
import { FeatureToggleModule } from 'projects/web/src/app/modules/feature-toggle/feature-toggle.module';
import { TranslateDomainModule } from '@web/app/pipes/translate/translate-domain.module';
import { TruncateModule } from '@pipes/truncate/truncate.module';
import { NewContactSidenavModule } from "@web/app/components/new-contact-sidenav/new-contact-sidenav.module";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import {
  DatePickerEmptyHeaderComponent,
  ReservationDetailComponent,
} from "@web/app/components/reservation-detail/reservation-detail.component";
import { ClientContactAutocompleteOptionModule } from "@web/app/components/reservation-detail/client-contact-autocomplete-option/client-contact-autocomplete-option.module";
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { OriginModule } from '@web/app/pipes/origin/origin.module';
import { GroupedReservationsDetailModule } from '@web/app/components/grouped-reservations-detail/grouped-reservations-detail.module';
import { NgEventBus } from 'ng-event-bus';
import { WsTooltipModule } from '@web/util/ws-ui/ws-tooltip/ws-tooltip.module';
import { InfoIconHoverableModule } from '../info-icon-hoverable/info-icon-hoverable.module';
import { ExternalSyncButtonModule } from '../external-sync-button/external-sync-button.module';
import { LetDirectiveModule } from '@web/app/directives/let/let.module';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';
import { RevokeReservationDialogModule } from '../dialogs/revoke-reservation-dialog/revoke-reservation-dialog.module';
import { RefundPaymentDialogModule } from '../dialogs/refund-payment-dialog/refund-payment-dialog.module';
import { PaymentsPaymentDetailDialogModule } from '@web/app/pages/payments/payments-payment-detail-dialog/payments-payment-detail-dialog.module';
import { AdditionalQuestionsPopupModule } from '../dialogs/additional-questions-popup/additional-questions-popup.module';
import { ReservationAdditionalQuestionsActionComponent } from './reservation-additional-questions-action/reservation-additional-questions-action.component';

@NgModule({
  declarations: [
    ReservationDetailComponent,
    DatePickerEmptyHeaderComponent,
    ReservationAdditionalQuestionsActionComponent,
  ],
  entryComponents: [ReservationDetailComponent, DatePickerEmptyHeaderComponent],
  exports: [
    ReservationDetailComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    FlexModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatMomentDateModule,
    NgxMaskModule,
    DurationModule,
    MatCheckboxModule,
    MatSelectModule,
    ConfirmModule,
    MatAutocompleteModule,
    LoadingModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    ArrayPipeModule,
    FeatureToggleModule,
    TranslateDomainModule,
    TruncateModule,
    NewContactSidenavModule,
    MatSlideToggleModule,
    MatGridListModule,
    MatDividerModule,
    MatCardModule,
    GroupedReservationsDetailModule,
    OriginModule,
    WsTooltipModule,
    InfoIconHoverableModule,
    LetDirectiveModule,
    TranslateDomainModule,
    ExternalSyncButtonModule,
    LetDirectiveModule,
    TranslateDomainModule,
    WsUiModule,
    RevokeReservationDialogModule,
    RefundPaymentDialogModule,
    PaymentsPaymentDetailDialogModule,
    AdditionalQuestionsPopupModule,
    ClientContactAutocompleteOptionModule,
  ], providers: [
    CurrencyPipe,
    NgEventBus
  ]
})
export class ReservationDetailModule { }